/*
 * @Description: 异常处理类
 * @Author: fengd
 * @LastEditors: fengd
 * @Date: 2019-03-13 11:12:49
 * @LastEditTime: 2019-09-11 15:36:16
 */

// 原生回调的错误类型
export const NATIVE_ERRORS = {
  c101: {
    description: '命令执行超时',
    retry: false
  },
  b001: {
    description: '蓝牙未授权',
    retry: false
  },
  b002: {
    description: '蓝牙连接超时',
    retry: true
  },
  b003: {
    description: '蓝牙鉴权失败',
    retry: false
  },
  b004: {
    description: '蓝牙心跳超时',
    retry: true
  },
  b005: {
    description: '蓝牙连接失败',
    retry: true
  },
  b006: {
    description: '蓝牙异常断开',
    retry: true
  },
  b007: {
    description: '蓝牙通知特性打开失败',
    retry: false
  }
};

// 与串口或蓝牙通信过程的错误码定义
export const COMMUNITION_ERRORS = {
  1: {
    description: '未知命令',
    retry: false
  },
  2: {
    description: '命令参数错误',
    retry: false
  },
  3: {
    description: '校验错误或CRC错误',
    retry: false
  },
  100: {
    description: '密钥认证失败(RFID/蓝牙)',
    retry: false
  },
  101: {
    description: 'RFID写入错误',
    retry: true
  },
  255: {
    description: '读卡器未放置',
    retry: true
  }
};
